module.exports = __webpack_public_path__ + "img/img1.628d3045.jpg";